import script from "./ViewHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHeader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__